import styled from 'styled-components';

import { color, focusStyle, removeScrollbars, space } from '../../stylesheets';

const StyledFilterSelect = styled.div`
  label {
    display: block;
    margin-bottom: ${space('s')};
    padding-top: ${space('s')};
  }

  .filter-select__menu {
    background: ${color('neutral', 10)};
    box-shadow: none;
    border: 2px solid ${color('primary', 50)};
    border-radius: 0;
    padding: 0;
    z-index: 990;
    margin: 0;
    margin-top: -2px;
  }

  .filter-select__menu-list {
    margin: 0;
    padding: 0;
  }

  .filter-select__option {
    background: ${color('neutral', 10)};
    color: ${color('neutral', 90)};
    padding: ${space('s')};

    &:hover,
    &:focus {
      background: ${color('base', 50)};
    }
  }

  .filter-select__container:focus-within {
    ${focusStyle()}
  }

  .filter-select--is-disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .filter-select__control {
    min-height: ${space('xl')};
    padding: 0;
    border: 2px solid ${color('primary', 10)};
    min-height: 50px;
    border-radius: 0;
    box-shadow: 0 0 0px 0px ${color('primary', 20)};
    transition: all 0.2s ease-in-out;
    background: transparent;

    &--is-focused {
      box-shadow: none;
    }

    &:hover,
    &:focus {
      outline: 0;
      border-color: ${color('primary', 10)};
      box-shadow: 0 0 5px 2px ${color('primary', 20)};
    }
  }

  .filter-select__multi-value {
    background: ${color('neutral', 30)};
    border: 2px solid ${color('neutral', 30)};
    border-radius: 0;
    margin: 2px 0px;
    margin-right: 4px;
    flex-shrink: 0;

    p {
      max-width: 150px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .filter-select__multi-value__remove {
    background: none;
    border-radius: 0;
    margin: 0;
    padding: 0;
    color: ${color('neutral', 50)};
    cursor: pointer;

    &:hover {
      background: ${color('neutral', 30)};
      color: ${color('neutral', 70)};
    }
  }

  .filter-select__value-container {
    padding: ${space(['xxs', 's'])};
    width: 100%;
    overflow: scroll;
    flex-wrap: nowrap;

    ${removeScrollbars}
  }

  .filter-select__indicator-separator {
    padding: 0;
    width: 0;
    background: none;
  }

  .filter-select__clear-indicator,
  .filter-select__dropdown-indicator {
    cursor: pointer;
    color: ${color('neutral', 70)};
  }
`;

export default StyledFilterSelect;
